"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrTranslator = void 0;
const base_1 = require("../common/base");
const pattern_1 = require("../common/pattern");
class OrTranslator extends base_1.Translator {
    translate(chunk, actions) {
        // TODO: use Array.flat
        chunk.children = [].concat(...chunk.children);
        const expression = pattern_1.translateChildren(chunk, actions).join(" / ");
        const pattern = `(${expression})`;
        return pattern;
    }
}
exports.OrTranslator = OrTranslator;
